import { Stack, StackProps } from '@mui/material'
import { FC } from 'react'
import { OrderItemCard } from 'components/ordering/OrderItemCard'
import { useOrdering } from 'hooks'

export const OrderItemsList: FC<StackProps> = (props) => {
  const { order } = useOrdering()
  return (
    <Stack {...props} spacing={2}>
      {order?.items?.map((item) => (
        <OrderItemCard key={item.id} orderItem={item} />
      ))}
    </Stack>
  )
}
